import React, { useState } from 'react';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { logErrorToConsole } from 'src/utils/util';
import {
    setClearFilter,
    setAppliedFilter,
    actionApplyFilterType,
    setFilterAppliedView,
    setAdminFilterParams,
    setShowLocalExpandedView,
    setAdminFilterParamValues,
    setAdminFilters,
    setAdminFilterOpen,
    getFilterData,
    getAdminUserList,
    getSalesOrgView,
    setSelectedSalesOrg,
    setDefaultvalue,
    updateSalesOrg,
    setFilterDetails,
    getFilterDetails,
    clearAdminFilters,
} from 'src/pages/admin/redux/action';
import CustomizeFilterView from 'src/pages/admin/filter/customizeFilterView/FilterView';
import { ADMIN_LIST_VIEW_FILTER_DROPDOWN } from 'src/constants/filterConstants.js';
import {
    TextBold,
    FilterBlock,
    EmptyBox,
} from 'src/pages/orders/components/orderListFilters/OrderListFilters.styled';
import {
    FilterHeading,
    Reset,
    FilterHeader,
    FilterContentMain,
    FilterHeaderContainer,
    FilterWrapperMain,
} from './index.styled';
import FilterDefaultCheckbox from 'src/pages/admin/filter/filterDefaultCheckbox';
import { setSelectedViews } from './../redux/action/index';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const AdminFilterBox = (props) => {
    const dispatch = useDispatch();
    const [apply, setApply] = useState(false);
    const [resetView, setResetView] = useState(false);
    const [searchValue] = useState('');
    const [isViewChange, setIsViewChange] = useState(false);
    const [isOneTimeCallRole, setIsOneTimeCallRole] = useState(false);
    const [isOneTimeCallTerritory, setIsOneTimeCallTerritory] = useState(false);
    const [isSalesOrgView, setSalesOrgView] = useState(true);
    const [defaultClicked, setDefaultClicked] = useState(false);
    const [isFilterValuesChanged, setIsFilterValuesChanged] = useState(false);
    const { saleOrgView, adminUser, selectedSalesOrgView, storedSalesOrgData } =
        useSelector((state) => ({
            saleOrgView: state.AdminReducer.adminUser?.salesOrgFilter,
            adminUser: state.AdminReducer.adminUser,
            selectedSalesOrgView: state.AdminReducer.selectedSalesOrgView,
            storedSalesOrgData: state.AdminReducer.selectedViews.salesOrgView,
        }));
    const defaultStatus = useSelector(
        (state) => state.AdminReducer.defaultStatus
    );

    const filterType = useSelector(
        (state) => state.AdminFilterReducer.filterType
    );
    const { salesOrg } = useSelector((state) => ({
        salesOrg: state.AdminReducer.salesOrg,
    }));
    const [checkedState, setChecked] = useState(saleOrgView);
    const [isFilterSelectedChanged, setIsFilterSelectedChanged] =
        useState(false);
    const { t } = useTranslation();

    const {
        roleSuccess,
        territorySuccess,
        districtSuccess,
        showLocalExpandedView,
    } = useSelector((state) => state.AdminReducer);

    const selectedViews = useSelector(
        (state) => state.AdminReducer.selectedViews
    );

    const { selectedSalesOrg } = useSelector((state) => ({
        selectedSalesOrg: state.AdminReducer.selectedSalesOrgView,
    }));

    const [defaultViews] = useState({
        salesOrgView: {
            name: 'All',
            value: 'All',
        },
        districtView: { id: 'All District', name: 'All' },
        territoryView: { id: 'All Territory', name: 'All' },
        roleView: { id: 'All', name: 'All' },
    });

    const initDistrict = [{ id: 'All District', name: 'All' }];

    const districtValue = useSelector((state) => state.AdminReducer?.districts);
    const dist = districtValue.filter(
        (item) =>
            item.districtCode !== 'GSE' && item.districtCode !== 'NOT_ASSIGNED'
    );
    let districtLists = districtSuccess
        ? dist.filter((district) => district.id === 'All District').length === 1
            ? [...dist]
            : [...initDistrict, ...dist]
        : [...initDistrict];

    const territoryValue = useSelector(
        (state) => state.AdminReducer?.territories
    );

    const initTerritory = [{ id: 'All Territory', name: 'All' }];

    let territoriesLists = territorySuccess
        ? territoryValue.filter((territory) => territory.id === 'All Territory')
              .length === 1
            ? [...territoryValue]
            : [...initTerritory, ...territoryValue]
        : [...initTerritory];
    const roleValues = useSelector((state) => state.AdminReducer.userRole);
    const initRoles = [{ id: 'All', name: 'All' }];
    let roleLists = roleSuccess
        ? roleValues.filter((role) => role.id === 'All').length === 1
            ? [...roleValues]
            : [...initRoles, ...roleValues]
        : [...initRoles];
    const onCheckBoxChange = (event, checkBoxName) => {
        const { checked, value } = event.target;
        const updateFilters = [...checkedState];
        const updateFilterIndex = updateFilters.findIndex(
            (x) => x.value === value
        );
        const allIndex = updateFilters.findIndex((x) => x.value === 'All');
        if (updateFilterIndex >= 0) {
            const updateChecked = { ...updateFilters[updateFilterIndex] };
            updateChecked.isChecked = checked;
            updateFilters[updateFilterIndex] = updateChecked;
        }
        if (value === 'All' && checked === true) {
            //check all selectd
            updateFilters.forEach((e) => {
                e.isChecked = false;
            });
            // setApply(false);
        }
        if (value != 'All') {
            updateFilters[allIndex].isChecked = false;
            // setApply(true);
        }
        if (
            value == 'All' ||
            (updateFilters || []).filter((it) => it.isChecked).length == 0
        ) {
            updateFilters[allIndex].isChecked = true;
        }
    setChecked(updateFilters);
    dispatch(setSelectedSalesOrg(updateFilters));

        dispatch(
            setFilterDetails({
                filterData: updateFilters.filter((item) => item.isChecked),
                filterType: 'salesOrg',
            })
        );
        setIsFilterSelectedChanged(!isFilterSelectedChanged);
        setIsFilterValuesChanged(true);
    dispatch(updateSalesOrg(updateFilters));
    dispatch(getSalesOrgView(updateFilters));
        dispatch(
            setSelectedViews({
                salesOrgView: updateFilters,
                districtView: {
                    id: 'All District',
                    name: 'All',
                    ...selectedViews.districtView,
                },
                territoryView: {
                    id: 'All Territory',
                    name: 'All',
                    ...selectedViews.territoryView,
                },
                roleView: { id: 'All', name: 'All', ...selectedViews.roleView },
            })
        );
        !isImpersonationActive &&
            window.sessionStorage.setItem(
                'selectedViews',
                JSON.stringify({
                    salesOrgView: updateFilters,
                    districtView: {
                        id: 'All District',
                        name: 'All',
                        ...selectedViews.districtView,
                    },
                    territoryView: {
                        id: 'All Territory',
                        name: 'All',
                        ...selectedViews.territoryView,
                    },
                    roleView: {
                        id: 'All',
                        name: 'All',
                        ...selectedViews.roleView,
                    },
                })
            );

        let appliedData = {
            appliedsalesOrgView: updateFilters,
            appliedDistrict: {
                id: 'All District',
                name: 'All',
                ...selectedViews.districtView,
            },
            appliedTerritory: {
                id: 'All Territory',
                name: 'All',
                ...selectedViews.territoryView,
            },
            appliedRole: {
                id: 'All',
                name: 'All',
                ...selectedViews.roleView,
            },
        };
        !isImpersonationActive &&
            window.sessionStorage.setItem(
                'appliedData',
                JSON.stringify(appliedData)
            );
        const param = {
            sortParams: 'name',
            salesOrgs: appliedData.appliedsalesOrgView
                .filter((salesOrg) => salesOrg.isChecked || salesOrg.isDefault)
                .map((s) => s.value)
                .join(','),
            filteredDistrict: appliedData.appliedDistrict?.id,
            filteredTerritory: appliedData.appliedTerritory?.id,
            filteredRole: appliedData.appliedRole?.id,
        };
        !isImpersonationActive &&
            sessionStorage.setItem('param', JSON.stringify(param));
        setDefaultView(updateFilters, false);
        //props.setFilterChange(!props.filterChange);
        // let tempUser = [];
        // if (checkBoxName === 'All') {
        //     tempUser = checkedState.map((user) => {
        //         if (user.name != 'All') {
        //             return { ...user, isChecked: false };
        //         } else {
        //             return { ...user, isChecked: true };
        //         }
        //     });
        //     // setChecked(tempUser);
        //     // dispatch(getSalesOrgView(tempUser));
        // } else {
        //     tempUser = checkedState.map((user) => {
        //         if (user.name == 'All') {
        //             return user.value === 'All'
        //                 ? { ...user, isChecked: false }
        //                 : user;
        //         } else {
        //             return user.value === value
        //                 ? { ...user, isChecked: checked }
        //                 : user;
        //         }
        //     });
        // }
        // setChecked(tempUser);
        // dispatch(getSalesOrgView(tempUser));
        // if (checkBoxName && checked) {
        //     setSalesOrgViewSelectedValue([
        //         ...salesOrgViewSelectedValue,
        //         checkBoxName,
        //     ]);
        //     // let selectedArray = [...selectedArray, checkBoxName];
        //     // selectedArray.push(checkBoxName);
        // }
        // setSelectedViews({
        //     ...selectedViews,
        //     salesOrgView: [...salesOrgViewSelectedValue, checkBoxName],
        // });
    };

    const setDefaultView = (salesOrg, value) => {
        
        let salesOrgsData = []; 
        const updatedSalesOrg = (salesOrg || []).map((item) => {
            if(item.name === 'All' ){
                item.isChecked && salesOrgsData.push(item.value);
                return value ? { ...item, isDefault: item.isChecked }: item;
            }
            else if (item.isChecked) {
                salesOrgsData.push(item.value);
                return value ? { ...item, isDefault: true } : item;
            }
            return item;
        });
        const param = {
            isDefaultSalesOrg: value ? true : false,
            sortParams: 'name',
            salesOrgs: salesOrgsData.join(','),
            filteredDistrict: appliedView.appliedDistrict.id,
            filteredTerritory: appliedView.appliedTerritory.id,
            filteredRole: appliedView.appliedRole.id,
        };
        sessionStorage.setItem('param', JSON.stringify(param)); 
        value && dispatch(setDefaultvalue(true));
        dispatch(
            getAdminUserList(param, '', value ? true : false, selectedSalesOrg)
        );
        dispatch(getFilterData(true));
       dispatch(setSelectedSalesOrg(updatedSalesOrg));
    };

    const { filter } = useSelector((state) => state.appliedOrdersFilterReducer);

    const isImpersonationActive = useSelector(
        (state) => state.impersonationReducer.isImpersonationActive
    );

    const { appliedView } = useSelector((state) => state.AdminReducer);

    const { district, territory, role } = filter;

    const updateExpandView = (componentName) => {
        if (componentName.view === 'Sales Org View') {
            setSalesOrgView(componentName.value);
        }
        dispatch(
            setShowLocalExpandedView({
                ...showLocalExpandedView,
                [componentName.view]: componentName.value,
            })
        );
    };

    const setInitialValue = () => {
        const updateSelectedViews = { ...selectedViews };
        const filteredDist = districtValue.filter(
            (item) =>
                item.districtCode !== 'GSE' &&
                item.districtCode !== 'NOT_ASSIGNED'
        );
        if (
            !appliedView?.appliedDistrict?.id &&
            filteredDist.length === 1 &&
            !isOneTimeCallRole &&
            !isOneTimeCallTerritory &&
            selectedViews.districtView.id !== 'All Favorites'
        ) {
            const updateDistrict = { ...updateSelectedViews.districtView };
            updateDistrict.id = filteredDist[0].districtCode;
            updateDistrict.name = filteredDist[0].districtName;
            updateSelectedViews.districtView = updateDistrict;
            // dispatch(
            //     getTerritory({
            //         districtCode: filteredDist[0].districtCode,
            //         isOrderListingPage: true,
            //     })
            // );
            setIsOneTimeCallTerritory(true);
        }
        if (
            selectedViews?.districtView?.id !== 'All District' &&
            territoryValue.length === 1 &&
            !isOneTimeCallRole
        ) {
            const updateTerritory = { ...updateSelectedViews.territoryView };
            updateTerritory.id = territoryValue[0].terrirotryCode;
            updateTerritory.name = territoryValue[0].terrirotryName;
            updateSelectedViews.territoryView = updateTerritory;
            // dispatch(
            //     getUserRoles({
            //         district: selectedViews.districtView.id,
            //         territory: territoryValue[0].terrirotryCode,
            //     })
            // );
            setIsOneTimeCallRole(true);
        }
        if (
            appliedView?.appliedDistrict?.id &&
            districtValue.length > 0 &&
            !isViewChange
        ) {
            const updateDistrict = { ...updateSelectedViews.districtView };
            updateDistrict.id = appliedView?.appliedDistrict.id;
            updateDistrict.name = appliedView?.appliedDistrict.name;
            updateSelectedViews.districtView = updateDistrict;
        }

        if (
            appliedView?.appliedTerritory?.id &&
            territoryValue.length > 0 &&
            !isViewChange
        ) {
            const updateTerritory = {
                ...updateSelectedViews.territoryView,
            };
            updateTerritory.id = appliedView?.appliedTerritory.id;
            updateTerritory.name = appliedView?.appliedTerritory.name;
            updateSelectedViews.territoryView = updateTerritory;
        }
    };

    useEffectWithErrorLogging(() => {
        setInitialValue();
    }, [districtValue, territoryValue, roleValues]);

    useEffectWithErrorLogging(() => {
        const updateSelectedViews = { ...selectedViews };

        if (
            appliedView?.appliedDistrict?.id &&
            districtValue.length > 0 &&
            !isViewChange
        ) {
            const updateDistrict = { ...updateSelectedViews.districtView };
            updateDistrict.id = appliedView?.appliedDistrict.id;
            updateDistrict.name = appliedView?.appliedDistrict.name;
            updateSelectedViews.districtView = updateDistrict;
        }
        if (
            appliedView?.appliedTerritory?.id &&
            territoryValue.length > 0 &&
            !isViewChange
        ) {
            const updateTerritory = {
                ...updateSelectedViews.territoryView,
            };
            updateTerritory.id = appliedView?.appliedTerritory.id;
            updateTerritory.name = appliedView?.appliedTerritory.name;
            updateSelectedViews.territoryView = updateTerritory;
        }
        if (
            appliedView?.appliedRole?.id &&
            roleValues.length > 0 &&
            !isViewChange
        ) {
            const updateRole = {
                ...updateSelectedViews.roleView,
            };
            updateRole.id = appliedView?.appliedRole.id;
            updateRole.name = appliedView?.appliedRole.name;
            updateSelectedViews.roleView = updateRole;
        }
        updateSelectedViews.salesOrgView = saleOrgView;
    }, [districtValue, territoryValue, roleValues]);

    useEffectWithErrorLogging(() => {
        if (isFilterValuesChanged) {
            dispatch(
                getFilterDetails({
                    selectedView: selectedViews,
                    filterType: filterType,
                })
            );
            setIsFilterValuesChanged(false);
        }
    }, [isFilterSelectedChanged]);

    const handleAppliedFilter = (selectedViews) => {
        const view = { ...selectedViews };
        let filteredParams = {
            filteredSalesOrgView: '',
            filteredDistrict: '',
            filteredTerritory: '',
            filteredRole: '',
        };
        // appliedView.appliedsalesOrgView = view.salesOrgView
        //     ? [...view.salesOrgView]
        //     : [];
        // appliedView.appliedDistrict = { ...view.districtView };
        // appliedView.appliedTerritory = { ...view.territoryView };
        // appliedView.appliedRole = { ...view.roleView };
        let appliedData = {
            appliedsalesOrgView: view.salesOrgView,
            appliedDistrict: { ...view.districtView },
            appliedTerritory: { ...view.territoryView },
            appliedRole: { ...view.roleView },
        };
        !isImpersonationActive &&
            window.sessionStorage.setItem(
                'appliedData',
                JSON.stringify(appliedData)
            );
        let salesOrgsData = [];
        (salesOrg && salesOrg.length > 0
            ? salesOrg
            : selectedViews.salesOrgView
        ).map((item) => {
            if (item.isChecked || item.isDefault) {
                salesOrgsData.push(item.value);
            }
        });
        const param = {
            sortParams: 'name',
            salesOrgs: salesOrgsData.join(','),
            filteredDistrict: selectedViews?.districtView.id,
            filteredTerritory: selectedViews?.territoryView.id,
            filteredRole: selectedViews?.roleView.id,
        };
        !isImpersonationActive &&
            sessionStorage.setItem('param', JSON.stringify(param));

        dispatch(setAppliedFilter(appliedData));

        if (appliedData.appliedDistrict.name === 'All Districts') {
            dispatch(setAdminFilterOpen(false));
        } else {
            dispatch(getFilterData(true));
            filteredParams.filteredSalesOrgView =
                appliedData.appliedsalesOrgView.name === 'All'
                    ? ''
                    : appliedData.appliedsalesOrgView.value;
            filteredParams.filteredDistrict =
                appliedData.appliedDistrict.name === 'All Districts'
                    ? ''
                    : appliedData.appliedDistrict.id;
            filteredParams.filteredTerritory =
                appliedData.appliedTerritory.name === 'All Territories'
                    ? ''
                    : appliedData.appliedTerritory.id;
            filteredParams.filteredRole =
                appliedData.appliedRole.name === 'All'
                    ? ''
                    : appliedData.appliedRole.id;

            let filtervalues = [
                !['All'].includes(appliedData.appliedsalesOrgView)
                    ? appliedData.appliedsalesOrgView
                    : '',
                appliedData.appliedDistrict.name !== 'All Districts'
                    ? appliedData.appliedDistrict.name
                    : '',
                appliedData.appliedTerritory.name !== 'All Territories'
                    ? appliedData.appliedTerritory.name
                    : '',
                appliedData.appliedRole.name !== 'All'
                    ? appliedData.appliedRole.name
                    : '',
            ];
            // window.sessionStorage.setItem(
            //     'items',
            //     JSON.stringify(filtervalues)
            // );

            sessionStorage.setItem('FilterDataOpen', true);
            dispatch(setAdminFilterParams(filteredParams));
            dispatch(setFilterAppliedView(filtervalues));
            dispatch(setAdminFilterParamValues(filteredParams));
        }
    };

    const handleApplyFilters = () => {
        // salesOrg?.length > 0 && setChecked(salesOrg);
        !isImpersonationActive &&
            window.sessionStorage.setItem(
                'selectedViews',
                JSON.stringify(selectedViews)
            );
        handleAppliedFilter(selectedViews);
        // let salesOrgsData = [];
        // (salesOrg ? salesOrg : selectedViews.salesOrgView).map((item) => {
        //     if (item.isChecked || item.isDefault) {
        //         salesOrgsData.push(item.value);
        //     }
        // });
        // const param = {
        //     sortParams: 'name',
        //     salesOrgs: salesOrgsData.join(','),
        //     filteredDistrict: appliedView?.appliedDistrict.id,
        //     filteredTerritory: appliedView?.appliedTerritory.id,
        //     filteredRole: appliedView?.appliedRole.id,
        // };
        // sessionStorage.setItem('param',JSON.stringify(param));

        // props.onClose();
    };
    const onFilterChangeHandler = (event, filterName) => {
        dispatch(
            setFilterDetails({
                filterData: {
                    name: event.name,
                    id: event.id === 'All Roles' ? 'All' : event.id,
                },
                filterType: filterName,
            })
        );
        setIsFilterSelectedChanged(!isFilterSelectedChanged);
        setIsFilterValuesChanged(true);
        setIsViewChange(true);
        setIsOneTimeCallRole(false);
        setIsOneTimeCallTerritory(false);
        const viewUpdate = { ...selectedViews };
        const view = { ...viewUpdate[filterName] };
        view.id = event.id === 'All Roles' ? 'All' : event.id;
        view.name = event.name;
        viewUpdate[filterName] = view;
        if (ADMIN_LIST_VIEW_FILTER_DROPDOWN()[0].name === filterName) {
            viewUpdate['territoryView'] = updateDefaultView(
                viewUpdate,
                'territoryView'
            );
            viewUpdate['roleView'] = updateDefaultView(viewUpdate, 'roleView');
        }

        if (ADMIN_LIST_VIEW_FILTER_DROPDOWN()[1].name === filterName) {
            viewUpdate['roleView'] = updateDefaultView(viewUpdate, 'roleView');
            // viewUpdate['districtView'] = updateDefaultView(
            //     viewUpdate,
            //     'districtView'
            // );
        }
        // if (ADMIN_LIST_VIEW_FILTER_DROPDOWN()[2].name === filterName) {
        //     viewUpdate['territoryView'] = updateDefaultView(
        //         viewUpdate,
        //         'territoryView'
        //     );
        //     viewUpdate['districtView'] = updateDefaultView(
        //         viewUpdate,
        //         'districtView'
        //     );
        // }
 
        dispatch(setSelectedViews(viewUpdate));
        !isImpersonationActive &&
            window.sessionStorage.setItem(
                'selectedViews',
                JSON.stringify(viewUpdate)
            );

        let appliedData = {
            appliedsalesOrgView: viewUpdate.salesOrgView,
            appliedDistrict: { ...viewUpdate.districtView },
            appliedTerritory: { ...viewUpdate.territoryView },
            appliedRole: { ...viewUpdate.roleView },
        };
        !isImpersonationActive &&
            window.sessionStorage.setItem(
                'appliedData',
                JSON.stringify(appliedData)
            );
        const param = {
            sortParams: 'name',
            salesOrgs: appliedData.appliedsalesOrgView
                .filter((salesOrg) => salesOrg.isChecked || salesOrg.isDefault)
                .map((s) => s.value)
                .join(','),
            filteredDistrict: appliedData.appliedDistrict?.id,
            filteredTerritory: appliedData.appliedTerritory?.id,
            filteredRole: appliedData.appliedRole?.id,
        };
        !isImpersonationActive &&
            sessionStorage.setItem('param', JSON.stringify(param));
        setApply(true);
        // updateViewLists(viewUpdate, filterName);
    };
    const updateDefaultView = (view, type) => {
        if (type === 'territoryView') {
            const viewTerritory = { ...view[type] };
            // if (!viewTerritory.id) {
            viewTerritory.id = 'All Territory';
            viewTerritory.name = 'All';
            // }
            return viewTerritory;
        }
        if (type === 'roleView') {
            const viewRole = { ...view[type] };
            // if (!viewRole.id) {
            viewRole.id = 'All';
            viewRole.name = 'All';
            // }
            return viewRole;
        }

        // if (type === 'districtView') {
        //     const viewDistrict = { ...view[type] };
        //     // if (!viewDistrict.id) {
        //         viewDistrict.id = 'All District';
        //         viewDistrict.name = 'All';
        //     // }
        //     return viewDistrict;
        //}
        // switch (type) {
        //     case 'territoryView':
        //         const viewTerritory = { ...view[type] };
        //         viewTerritory.id = 'All Territory';
        //         viewTerritory.name = 'All';
        //         return viewTerritory;
        //     // case 'roleView':
        //     //     const viewRole = { ...view[type] };
        //     //     viewRole.id = 'All';
        //     //     viewRole.name = 'All';
        //     //     return viewRole;
        // }
    };
    useEffectWithErrorLogging(() => {
        if (saleOrgView && saleOrgView?.length > 0) {
            let salesOrgData = [...saleOrgView];
            setChecked(
                salesOrgData.map((item, i) =>
                    Object.assign({}, item, {
                        isChecked:
                            selectedViews &&
                            selectedViews.salesOrgView &&
                            selectedViews.salesOrgView.length &&
                            selectedViews.salesOrgView[i] &&
                            Object.prototype.hasOwnProperty.call(
                                selectedViews.salesOrgView[i],
                                'isChecked'
                            )
                                ? selectedViews.salesOrgView[i].isChecked
                                : false,
                    })
                )
            );
        }
    }, []);

    useEffectWithErrorLogging(() => {
        let salesOrgView = [];
        if (saleOrgView && saleOrgView?.length > 0) {
            let saleOrgViewData = [...saleOrgView];
            if (selectedSalesOrgView && selectedSalesOrgView.length) {
                saleOrgViewData = saleOrgView.map((item, i) =>
                    Object.assign({}, item, {
                        isChecked:
                            selectedSalesOrgView &&
                            selectedSalesOrgView.length > i &&
                            Object.prototype.hasOwnProperty.call(
                                selectedSalesOrgView[i],
                                'isChecked'
                            )
                                ? selectedSalesOrgView[i].isChecked : false,
                    })
                );
            } else if (
                !isImpersonationActive &&
                storedSalesOrgData &&
                storedSalesOrgData.length > 0
            ) {
                saleOrgViewData = saleOrgView.map((item, i) =>
                    Object.assign({}, item, {
                        isChecked:
                            storedSalesOrgData &&
                            storedSalesOrgData.length > i &&
                            Object.prototype.hasOwnProperty.call(
                                storedSalesOrgData[i],
                                'isChecked'
                            )
                                ? storedSalesOrgData[i].isChecked: false,
                    })
                );
            } else {
                // let saleOrgViewData = [...saleOrgView];
                saleOrgViewData.map((item) => {
                    if (
                        item.isDefault &&
                        ((item.value == 'All' &&
                            saleOrgViewData.filter(
                                (itemData) =>
                                    itemData.isDefault &&
                                    itemData.value != 'All'
                            ).length == 0) ||
                            item.value != 'All')
                    ) {
                        item.isChecked = true;
                    }
                });
                if (
                    saleOrgViewData.filter((item) => item.isDefault).length == 0
                ) {
                    const allIndex = saleOrgViewData.findIndex(
                        (x) => x.value === 'All'
                    );
                    saleOrgViewData[allIndex].isChecked = true;
                }
            }
            dispatch(setSelectedSalesOrg(saleOrgViewData));
            setChecked(saleOrgViewData);
            salesOrgView = [...saleOrgViewData];

            dispatch(updateSalesOrg(saleOrgViewData));
        } else {
            let salesOrgData = [...salesOrg];
            if (
                salesOrgData?.length > 0 &&
                salesOrgData.filter((item) => item.isDefault).length == 0
            ) {
                const allIndex = salesOrgData.findIndex(
                    (x) => x.value === 'All'
                );
                salesOrgData[allIndex].isChecked = true;
            }
            setChecked(salesOrgData);
            salesOrgView = [...salesOrgData];
        }

        const param = {
            sortParams: 'name',
            salesOrgs: salesOrgView
                .filter((salesOrg) => salesOrg.isChecked || salesOrg.isDefault)
                .map((s) => s.value)
                .join(','),
            filteredDistrict: selectedViews?.districtView.id,
            filteredTerritory: selectedViews?.territoryView.id,
            filteredRole: selectedViews?.roleView.id,
        };
        !isImpersonationActive &&
            sessionStorage.setItem('param', JSON.stringify(param));
    }, []);

    useEffectWithErrorLogging(() => {
        if (saleOrgView?.length > 0) {
            let saleOrgViewData = [...saleOrgView];
            saleOrgViewData = saleOrgView.map((item, i) =>
                Object.assign({}, item, {
                    isChecked:
                        selectedSalesOrgView &&
                        selectedSalesOrgView.length > i &&
                        Object.prototype.hasOwnProperty.call(
                            selectedSalesOrgView[i],
                            'isChecked'
                        )
                            ? selectedSalesOrgView[i].isChecked
                            : false,
                })
            );
            // saleOrgViewData.map((item) => {
            //     if (item.isDefault) {
            //         item.isChecked = true;
            //     }
            // });
            // if (
            //     saleOrgViewData.filter(
            //         (item) => item.isDefault || item.isChecked
            //     ).length == 0
            // ) {
            //     saleOrgViewData[0].isChecked = true;
            // }
            // dispatch(setSelectedSalesOrg(saleOrgViewData));
            dispatch(updateSalesOrg(saleOrgViewData));
        }
    }, [adminUser && adminUser?.status, selectedSalesOrg]);
    useEffectWithErrorLogging(() => {
        if (defaultStatus) {
            // let salesOrgData = salesOrgViewData &&
            //     salesOrgViewData.length > 0 && [...salesOrgViewData];
            let salesOrgData = saleOrgView &&
                saleOrgView.length > 0 && [...saleOrgView];
            salesOrgData &&
                salesOrgData.length > 0 &&
                salesOrgData.map((item) => {
                    if (item.isDefault) {
                        item.isChecked = true;
                    }
                });
            setChecked(salesOrgData);
        }
    }, [defaultStatus]);
    // useEffectWithErrorLogging(() => {
    //     let salesOrgData = [...salesOrg];
    //     // if (salesOrgData.filter((item) => item.isDefault).length == 0) {
    //     //     if (salesOrgData && salesOrgData[0]) {
    //     //         salesOrgData[0].isChecked = true;
    //     //     }
    //     // }
    //     setChecked(salesOrgData);
    // }, [defaultStatus]);

    // const updateViewLists = (viewUpdate, filterName) => {
    //     // if (
    //     //     viewUpdate?.districtView?.id === 'All District' ||
    //     //     viewUpdate?.districtView?.id === 'All Favorites'
    //     //     // viewUpdate?.territoryView?.id === 'All Territory'
    //     // ) {
    //     //     dispatch(resetRoles());
    //     //     dispatch(setAdminFilters({}));
    //     // }
    //     switch (filterName) {
    //         case ADMIN_LIST_VIEW_FILTER_DROPDOWN()[0].name:
    //             // viewUpdate?.districtView?.id === 'All District' ||
    //             // viewUpdate?.districtView?.id === 'All Favorites'
    //             //     ? // viewUpdate?.territoryView?.id === 'All Territory'
    //             //       //   (dispatch(resetTerritory()), dispatch(resetRoles()))
    //             //       dispatch(getTerritory())
    //             //     : dispatch(
    //             //           getTerritory({
    //             //               districtCode: viewUpdate.districtView.id,
    //             //               isOrderListingPage: true,
    //             //           })
    //             //       );
    //             // //   dispatch(resetRoles()));
    //             // dispatch(getUserRoles());
    //             return;

    //         case ADMIN_LIST_VIEW_FILTER_DROPDOWN()[1].name:
    //             if (
    //                 viewUpdate?.districtView?.id !== 'All District' &&
    //                 viewUpdate?.territoryView?.id !== 'All Territory'
    //             ) {
    //                 // dispatch(
    //                 //     getUserRoles({
    //                 //         district: viewUpdate.districtView.id,
    //                 //         territory:
    //                 //             viewUpdate.territoryView.id === 'GSE_T'
    //                 //                 ? 'GSE'
    //                 //                 : viewUpdate.territoryView.id,
    //                 //         isOrderListingPage: true,
    //                 //     })
    //                 // );
    //             }
    //             // else {
    //             //     dispatch(resetRoles());
    //             // }
    //             return;
    //     }
    // };

    const resetHandler = (filterType) => {
        dispatch(clearAdminFilters(true));
        let salesOrgViewDataDetails = saleOrgView &&
            saleOrgView.length > 0 && [...saleOrgView];
        salesOrgViewDataDetails &&
            salesOrgViewDataDetails.length > 0 &&
            salesOrgViewDataDetails.map((item) => {
                if (item.isDefault) {
                    item.isChecked = true;
                } else {
                    item.isChecked = false;
                }
            });
        dispatch(
            getFilterDetails({
                selectedView: { salesOrgView: salesOrgViewDataDetails },
                filterType: 'salesOrg',
            })
        );
        sessionStorage.removeItem('items');
        sessionStorage.removeItem('SalesOrgView');
        if (!isImpersonationActive) {
            sessionStorage.removeItem('selectedViews');
            sessionStorage.removeItem('param');
            sessionStorage.removeItem('appliedData');
        }
        dispatch(
            setAppliedFilter({
                appliedsalesOrgView: [],
                appliedDistrict: {},
                appliedTerritory: {},
                appliedRole: {},
            })
        );
        setApply(false);
        sessionStorage.removeItem('items');
        let tempUser = saleOrgView.map((user) => {
            if (user.isDefault) {
                return { ...user, isChecked: true };
            } else {
                return { ...user, isChecked: false };
            }
        });
        setChecked(tempUser);

        if (dist?.length === 1 && territoryValue?.length === 1) {
            setInitialValue();
        }
        dispatch(setAdminFilterParamValues(''));
        if (
            appliedView?.appliedDistrict?.name &&
            appliedView.appliedDistrict.name !== 'All Districts'
        ) {
            dispatch(setClearFilter(true));
            dispatch(getFilterData(false));
            dispatch(getAdminUserList());
            dispatch(setAdminFilters({}));
            dispatch(
                setShowLocalExpandedView({
                    salesOrgView: true,
                    districtView: true,
                    territoryView: false,
                    roleView: false,
                })
            );
            let salesOrgData = saleOrgView &&
                saleOrgView.length > 0 && [...saleOrgView];
            salesOrgData &&
                salesOrgData.length > 0 &&
                salesOrgData.map((item) => {
                    if (item.isDefault) {
                        item.isChecked = true;
                    } else {
                        item.isChecked = false;
                    }
                });
            dispatch(updateSalesOrg(salesOrgData));
            dispatch(setSelectedSalesOrg(salesOrgData));

            // dispatch(resetRoles());
            // dispatch(resetTerritory());
            // dispatch(getTerritory({ isOrderListingPage: true }));

            if (filterType === 'View' && !resetView) {
                return;
            }
            switch (filterType) {
                case 'View': {
                    dispatch(
                        setSelectedViews({
                            salesOrgView: salesOrgData,
                            districtView: {
                                id: 'All District',
                                name: 'All',
                            },
                            territoryView: {
                                id: 'All Territory',
                                name: 'All',
                            },
                            roleView: { id: 'All', name: 'All' },
                        })
                    );
                    resetAppliedView();
                    !isImpersonationActive &&
                        window.sessionStorage.setItem(
                            'selectedViews',
                            JSON.stringify({
                                salesOrgView: salesOrgData,
                                districtView: {
                                    id: 'All District',
                                    name: 'All',
                                },
                                territoryView: {
                                    id: 'All Territory',
                                    name: 'All',
                                },
                                roleView: { id: 'All', name: 'All' },
                            })
                        );
                    let appliedData = {
                        appliedsalesOrgView: salesOrgData,
                        appliedDistrict: {
                            id: 'All District',
                            name: 'All',
                        },
                        appliedTerritory: {
                            id: 'All Territory',
                            name: 'All',
                        },
                        appliedRole: { id: 'All', name: 'All' },
                    };
                    !isImpersonationActive &&
                        window.sessionStorage.setItem(
                            'appliedData',
                            JSON.stringify(appliedData)
                        );
                    const param = {
                        sortParams: 'name',
                        salesOrgs: appliedData.appliedsalesOrgView
                            .filter(
                                (salesOrg) =>
                                    salesOrg.isChecked || salesOrg.isDefault
                            )
                            .map((s) => s.value)
                            .join(','),
                        filteredDistrict: appliedData.appliedDistrict?.id,
                        filteredTerritory: appliedData.appliedTerritory?.id,
                        filteredRole: appliedData.appliedRole?.id,
                    };
                    !isImpersonationActive &&
                        sessionStorage.setItem('param', JSON.stringify(param));
                    dispatch(actionApplyFilterType('ResetView'));
                    return;
                }
            }
        } else {
            let salesOrgsDataValues = [...saleOrgView];
            let salesOrgsDataDetails = [];
            let selectedSalesOrgViewData = [];
            salesOrgsDataValues.map((item) => {
                if (item.isDefault) {
                    item.isChecked = true;
                    salesOrgsDataDetails.push(item.value);
                    selectedSalesOrgViewData.push(item);
                } else {
                    item.isChecked = false;
                    selectedSalesOrgViewData.push(item);
                }
            });
            const param = {
                isDefaultSalesOrg: true,
                sortParams: 'name',
                salesOrgs: salesOrgsDataDetails.join(','),
                pageNum: '',
            };
            dispatch(
                setSelectedViews({
                    salesOrgView: saleOrgView,
                    districtView: {
                        id: 'All District',
                        name: 'All',
                    },
                    territoryView: {
                        id: 'All Territory',
                        name: 'All',
                    },
                    roleView: { id: 'All', name: 'All' },
                })
            );
            !isImpersonationActive &&
                window.sessionStorage.setItem(
                    'selectedViews',
                    JSON.stringify({
                        salesOrgView: saleOrgView,
                        districtView: {
                            id: 'All District',
                            name: 'All',
                        },
                        territoryView: {
                            id: 'All Territory',
                            name: 'All',
                        },
                        roleView: { id: 'All', name: 'All' },
                    })
                );
            let appliedData = {
                appliedsalesOrgView: saleOrgView,
                appliedDistrict: {
                    id: 'All District',
                    name: 'All',
                },
                appliedTerritory: {
                    id: 'All Territory',
                    name: 'All',
                },
                appliedRole: { id: 'All', name: 'All' },
            };
            !isImpersonationActive &&
                window.sessionStorage.setItem(
                    'appliedData',
                    JSON.stringify(appliedData)
                );
            const params = {
                sortParams: 'name',
                salesOrgs: appliedData.appliedsalesOrgView
                    .filter(
                        (salesOrg) => salesOrg.isChecked || salesOrg.isDefault
                    )
                    .map((s) => s.value)
                    .join(','),
                filteredDistrict: appliedData.appliedDistrict?.id,
                filteredTerritory: appliedData.appliedTerritory?.id,
                filteredRole: appliedData.appliedRole?.id,
            };
            !isImpersonationActive &&
                sessionStorage.setItem('param', JSON.stringify(params));
            dispatch(
                setShowLocalExpandedView({
                    salesOrgView: true,
                    districtView: true,
                    territoryView: false,
                    roleView: false,
                })
            );
            // dispatch(resetRoles());
            // dispatch(resetTerritory());
            // dispatch(getTerritory({ isOrderListingPage: true }));

            dispatch(setClearFilter(true));
            dispatch(getFilterData(false));
            dispatch(setDefaultvalue(false));
            window.sessionStorage.setItem(
                'SalesOrgView',
                JSON.stringify(selectedSalesOrgViewData)
            );
            dispatch(setSelectedSalesOrg(selectedSalesOrgViewData));

            // setIsFilterSelectedChanged(!isFilterSelectedChanged);
            dispatch(getAdminUserList(param, '', false, tempUser));
        }
    };

    const resetAppliedView = () => {
        if (appliedView) {
            appliedView.appliedsalesOrgView = {};
            appliedView.appliedDistrict = {};
            appliedView.appliedTerritory = {};
            appliedView.appliedRole = {};
        }
        sessionStorage.removeItem('items');

        dispatch(
            setAppliedFilter({
                appliedsalesOrgView: [],
                appliedDistrict: {},
                appliedTerritory: {},
                appliedRole: {},
            })
        );
    };

    useEffectWithErrorLogging(() => {
        // let checkDistrict = false,
        //     checkTerritory = false,
        //     checkRole = false;

        const checkSeletedView = { ...selectedViews };

        // checkDistrict =
        //     district === ''
        //         ? checkSeletedView.districtView.id !== 'All District'
        //         : district !== checkSeletedView.districtView.id;

        // checkTerritory =
        //     territory === ''
        //         ? checkSeletedView.territoryView.id !== 'All Territory'
        //         : territory !== checkSeletedView.territoryView.id;

        // checkRole =
        //     role === ''
        //         ? checkSeletedView.roleView.id !== 'All'
        //         : role !== checkSeletedView.roleView.id;

        // if (checkDistrict || checkTerritory || checkRole) {
        //     setApply(true);
        // } else {
        //     setApply(false);
        // }

        let checkResetView = false;

        checkResetView =
            checkSeletedView?.districtView?.id !== 'All District' ||
            checkSeletedView?.territoryView?.id !== 'All Territory' ||
            checkSeletedView?.roleView?.id !== 'All' ||
            district !== '' ||
            territory !== '' ||
            role !== '';

        checkResetView ? setResetView(true) : setResetView(false);
    }, [selectedViews]);

    const checkDefaultSelected = (selectedViewFilter, defaultViewFilter) => {
        if (selectedViewFilter?.id === defaultViewFilter?.id) {
            return true;
        } else {
            return false;
        }
    };

    return (
        <>
            <FilterBlock>
                <FilterWrapperMain className="FilterWrapperMain" bannerHeight={props.bannerHeight}>
                    <FilterHeader>
                        <FilterHeaderContainer>
                            <FilterHeading
                                filterAdmin
                                style={{
                                    fontFamily: 'AvenirNextWorld bold',
                                    paddingTop: '20px',
                                }}
                            >
                                {t('accounts.accountFilter.title')}
                            </FilterHeading>
                        </FilterHeaderContainer>
                        <div
                            id="admin-filter-resetButton"
                            onClick={() => {
                                try {
                                    resetHandler('View');
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                        >
                            <Reset isView={true}>
                                {' '}
                                {t('accounts.accountFilter.reset')}
                            </Reset>
                        </div>
                    </FilterHeader>
                    <FilterContentMain>
                        <FilterDefaultCheckbox
                            key={defaultStatus}
                            header={t('common.salesorgview')}
                            filters={checkedState}
                            defaultViewFilter={defaultViews.salesOrgView}
                            isExpanded={isSalesOrgView}
                            view="Sales Org View"
                            updateExpandedViews={updateExpandView}
                            selectedViewFilter={checkedState ? checkedState : []}
                            setDefaultAction={true}
                            onCheckBoxChange={onCheckBoxChange}
                            showDefault={true}
                            isAdmin={true}
                            setDefaultView={setDefaultView}
                            setDefaultClicked={setDefaultClicked}
                            defaultClicked={defaultClicked}
                        />

                        <>
                            {ADMIN_LIST_VIEW_FILTER_DROPDOWN()?.map((view) => {
                                return (
                                    <CustomizeFilterView
                                        PlaceHolder={
                                            view.value ===
                                            t(
                                                'admin.adminFilter.filterByDistrict'
                                            )
                                                ? t(
                                                      'admin.nameDetails.district'
                                                  )
                                                : view.value ===
                                                  t(
                                                      'admin.adminFilter.filterByTerritory'
                                                  )
                                                ? t(
                                                      'admin.nameDetails.territory'
                                                  )
                                                : t('admin.adminList.roles')
                                        }
                                        key={view.value}
                                        header={view.value}
                                        viewFilterName={view.name}
                                        viewFiltersLists={
                                            view.value ===
                                            t(
                                                'admin.adminFilter.filterByDistrict'
                                            )
                                                ? districtLists
                                                : view.value ===
                                                  t(
                                                      'admin.adminFilter.filterByTerritory'
                                                  )
                                                ? territoriesLists
                                                : roleLists
                                        }
                                        isExpanded={
                                            view.value ===
                                            t(
                                                'admin.adminFilter.filterByDistrict'
                                            )
                                                ? showLocalExpandedView?.districtView
                                                    ? showLocalExpandedView.districtView
                                                    : false
                                                : view.value ===
                                                  t(
                                                      'admin.adminFilter.filterByTerritory'
                                                  )
                                                ? showLocalExpandedView?.territoryView
                                                    ? showLocalExpandedView.territoryView
                                                    : false
                                                : showLocalExpandedView?.roleView
                                                ? showLocalExpandedView.roleView
                                                : false
                                        }
                                        updateExpandedViews={updateExpandView}
                                        selectedViewFilter={
                                            view.value ===
                                            t(
                                                'admin.adminFilter.filterByDistrict'
                                            )
                                                ? selectedViews?.districtView
                                                : view.value ===
                                                  t(
                                                      'admin.adminFilter.filterByTerritory'
                                                  )
                                                ? selectedViews?.territoryView
                                                : selectedViews?.roleView
                                        }
                                        setSelectedViewFilter={
                                            onFilterChangeHandler
                                        }
                                        // isAccountView={
                                        //     view.value === 'Filter by Role'
                                        //         ? true
                                        //         : false
                                        // }
                                        isShowAppliedView={true}
                                        showDefault={false}
                                        defaultViewFilter={
                                            view.value ===
                                            t(
                                                'admin.adminFilter.filterByDistrict'
                                            )
                                                ? defaultViews.districtView
                                                : view.value ===
                                                  t(
                                                      'admin.adminFilter.filterByTerritory'
                                                  )
                                                ? defaultViews.territoryView
                                                : defaultViews.roleView
                                        }
                                        showDot={
                                            !checkDefaultSelected(
                                                view.value ===
                                                    t(
                                                        'admin.adminFilter.filterByDistrict'
                                                    )
                                                    ? selectedViews.districtView
                                                    : view.value ===
                                                      t(
                                                          'admin.adminFilter.filterByTerritory'
                                                      )
                                                    ? selectedViews.territoryView
                                                    : selectedViews.roleView,
                                                view.value ===
                                                    t(
                                                        'admin.adminFilter.filterByDistrict'
                                                    )
                                                    ? defaultViews.districtView
                                                    : view.value ===
                                                      t(
                                                          'admin.adminFilter.filterByTerritory'
                                                      )
                                                    ? defaultViews.territoryView
                                                    : defaultViews.roleView
                                            )
                                        }
                                        isFilterDisable={false}
                                        width={'250px'}
                                        smbWidth={'200px'}
                                        // whiteSpace={'nowrap'}
                                        // overFlow={'hidden'}
                                        // textOverflow={'ellipsis'}
                                        searchValue={searchValue}
                                    />
                                );
                            })}
                        </>
                        <EmptyBox mobileMargin="15%"></EmptyBox>
                        <BottomNavigation
                            justifyContent={'space-evenly'}
                            opacity={'1'}
                            position={'absolute'}
                            padding={'11px'}
                        >
                            <Button
                                id={'page-admin-filter-close'}
                                show={true}
                                //secondary={true}
                                variant={ButtonStyles.secondary}
                                width={'40%'}
                                height={'38px'}
                                clicked={() => {
                                    try {
                                        props.onClose();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                            >
                                <TextBold color={'#1010EB'}>
                                    {t('accounts.accountFilter.close')}
                                </TextBold>
                            </Button>
                            <Button
                                id={'page-admin-filter-apply'}
                                show={true}
                                // primary={apply ? true : false}
                                disabled={apply ? false : true}
                                variant={apply ? ButtonStyles?.primary : ButtonStyles?.disabled}
                                width={'40%'}
                                height={'38px'}
                                clicked={() => {
                                    try {
                                        handleApplyFilters();
                                        // props.onClose();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                            >
                                <TextBold color={'#FFFF'}>
                                    {t('accounts.accountFilter.apply')}
                                </TextBold>
                            </Button>
                        </BottomNavigation>
                    </FilterContentMain>
                </FilterWrapperMain>
            </FilterBlock>
        </>
    );
};

export default AdminFilterBox;
